import "slick-carousel";
import $ from "jquery";

$(() => {
  const impactSlider = $(".js-impact-slider");

  if (!impactSlider.length) {
    return;
  }

  impactSlider.slick({
    arrows: true,
    dots: false,
    centerMode: true,
    infinite: true,
    slidesToShow: 1,
    variableWidth: true,
    initialSlide: 0,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  });
});
